import { baseClient } from './baseRequest';

const authClient = {
  // Triggers a branded verification email via the backend (Firebase link + Klaviyo flow).
  // Uses the current user's Bearer token; the backend resolves the email from the token.
  // Resolves on success; rejects if the backend fails so the caller can surface it.
  sendVerificationEmail: (): Promise<void> =>
    baseClient.post<void>({ url: '/auth/email/verification' }),

  // Triggers a branded password-reset email via the backend. Public (user is logged out).
  sendPasswordResetEmail: (email: string): Promise<void> =>
    baseClient.post<void>({
      url: '/auth/email/password-reset',
      body: { email },
    }),
};

export default authClient;
